import React, {createRef} from 'react';
import MoneyDeliveryPrintButtonProperties from "./MoneyDeliveryPrintButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import MoneyDeliveryPrintStore from "./MoneyDeliveryPrintStore";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./MoneyDeliveryPrintButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import PrintButton from "../PrintButton/PrintButton";
import {CurrencyModule} from '../../../util/Currency';
import SidePanel from "../../../ui_components/SidePanel/SidePanel";
import clsx from 'clsx';
import ShowOrderNumber from '../../Info/ShowOrderNumber/ShowOrderNumber';
import ShowDate from '../../Info/ShowDate/ShowDate';


const MoneyDeliveryPrintButton: React.FC<MoneyDeliveryPrintButtonProperties> = ({
                                                                      onClick = () => {
                                                                      },
                                                                      onSave = () => {
                                                                      },
                                                                      children,
                                                                      showIcon = true,
                                                                      showText = true,
                                                                      disabled,
                                                                      className = '',
                                                                      productOrderIds,
                                                                      rounded = false,
                                                                      showButton = true,
                                                                      size = ButtonSize.DEFAULT,
                                                                      type = ButtonType.DEFAULT
                                                                  }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new MoneyDeliveryPrintStore(commonContext, productOrderIds);
    const containerRef = createRef<HTMLDivElement>()


    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
        if (onSave) {
            onSave();
        }
    }

    const text = "Imprimir";
    const Icon = LocalPrintshopIcon;
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? <Icon/> : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? <Icon/> : <></>}
        />
    }

    const InvoiceData: React.FC<{ signerRole: string }> = ({signerRole}) => {
        return <div className={classes.invoice_data_container}>
            {store.moneyDeliveryOrders.map((moneyDeliveryOrder, i) => (<div className={clsx(classes.body, i > 0 && classes.order_item_container)}>
                <div className={classes.column_container}>
                    <div className={classes.column}>
                        <div className={classes.row}>
                            <div className={classes.subtitle}>{`${i18n.translate("CLIENT")}:`} </div>
                            &nbsp;
                            <div>{moneyDeliveryOrder.clientName}</div>
                        </div>
                        <div className={classes.row}>
                            <div className={classes.width_90}>
                                <div className={classes.sign_container}/>
                                <div className={classes.row}>
                                    <div className={classes.subtitle}>{`CI`} </div>
                                </div>
                            </div>
                        </div>
                        <div className={classes.row}>
                            <div className={classes.width_90}>
                                <div className={classes.sign_container}/>
                                <div className={classes.row}>
                                    <div className={classes.subtitle}>{`Firma y Fecha`} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.column}>
                        <div className={classes.row}>
                            <div className={classes.subtitle}>{`${i18n.translate("ADDRESSEE")}:`} </div>
                        </div>
                        <div className={classes.row}>
                            {moneyDeliveryOrder.contactName}
                        </div>
                        <div className={classes.row}>
                            {moneyDeliveryOrder.contactPhone && moneyDeliveryOrder.contactPhone?.number !== '' && <span>{'Celular: ' + moneyDeliveryOrder.contactPhone.number}</span>}
                            {moneyDeliveryOrder.contactHomePhone && moneyDeliveryOrder.contactHomePhone?.number !== '' && <span>{'Fijo: ' + moneyDeliveryOrder.contactHomePhone.number}</span>}
                            {moneyDeliveryOrder.contactSecondMobilePhone && moneyDeliveryOrder.contactSecondMobilePhone?.number !== '' && <span>{'Celular: ' + moneyDeliveryOrder.contactSecondMobilePhone.number}</span>}
                        </div>
                        <div className={classes.row}> 
                            {!moneyDeliveryOrder.isBankCard && <span><strong>Entregar en: </strong> {moneyDeliveryOrder.address}. {moneyDeliveryOrder.geo.name + '. ' + moneyDeliveryOrder.geo.parentInfo}</span>}
                            {moneyDeliveryOrder.isBankCard && <span><strong>Transferir a: </strong> {moneyDeliveryOrder?.contactBankCardNumber + ' ' + moneyDeliveryOrder?.contactBankCardBank}</span>}
                        </div>
                        {moneyDeliveryOrder.observations && <div className={classes.row}><span><strong>Observaciones: </strong>{moneyDeliveryOrder.observations}</span></div>}
                    </div>
                    <div className={classes.column}>
                        <div>
                            <ShowOrderNumber orderNumber={moneyDeliveryOrder.orderNumber}/>
                        </div>
                        <div className={classes.row}>
                            <ShowDate timestamp={moneyDeliveryOrder.createdAt} showTime={false} className={classes.margin_top_4}/>
                        </div>
                        <div className={clsx(classes.row,classes.margin_top_8)}>
                            <strong>Valor: {CurrencyModule.format(moneyDeliveryOrder?.totalToReceive || 0, moneyDeliveryOrder?.currencyToReceive)}</strong>
                        </div>
                    </div>
                </div>
                <div className={classes.message_container}>
                    <small  className={classes.message_text}><strong>NOTA:</strong> Al firmar este recibo, estoy de acuerdo con la calidad y denominación de los billetes, por lo que no procede reclamación.</small>
                </div>
            </div>))}
        </div>
    }

    return <Observer>
        {() => (
            <>
                <SidePanel loading={store.loading} title={`Orden de envio`}
                           onClose={onCloseModal} open={store.isModalOpen} className={classes.modal_container}>
                    <div className={classes.view_invoice_container}>
                        <div className={classes.toolbar_container}>
                            <PrintButton type={ButtonType.DEFAULT} onClick={() => {
                                containerRef.current?.scroll(0, 0);
                            }}/>
                        </div>
                        <div className={classes.invoice_container} ref={containerRef}>
                            <div>
                                <InvoiceData signerRole={i18n.translate("ADDRESSEE")}/>
                            </div>
                        </div>
                    </div>
                </SidePanel>
                {showButton && <Btn/>}
                {!showButton && <div onClick={handleOnclick}>{children}</div>}
            </>
        )}
    </Observer>
}

export default MoneyDeliveryPrintButton;
